module.exports = __webpack_public_path__ + "img/check-alt.7f2e0a04.svg";